import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { useAdminOrderStore } from "src/hooks/admin/order";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import Helper from "../../../helper/Helper";
import System from 'src/helper/system';

const OrderAuditLogPopup = ({ SetStatus }) => {
    const [{ }, { get_admin_order_audit_log }] = useAdminOrderStore();
    const [__check] = useAxiosIndicatorCheck();
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [auditList, setAuditList] = useState([]);

    const onHide = () => {
        SetStatus(false);
    };

    const urlParams = System.getParams();

    useEffect(() => {
        async function fetchHere() {
            __set("ADMIN_AUDIT_LOG_LIST");
            const data = await get_admin_order_audit_log(urlParams);
            setAuditList(data.data);
            __remove("ADMIN_AUDIT_LOG_LIST");
        }
        fetchHere();
    }, []);

    const [columnDefs] = useState([
        {
            field: 'fieldName',
            headerName: 'FIELD NAME',
            headerTooltip: 'FIELD NAME',
            unSortIcon: true,
            sortable: true,
            comparator: Helper.textSortingAgGrid,
        },
        {
            field: "newValue",
            headerName: "UPDATED VALUE",
            minWidth: 218,
            unSortIcon: true,
            comparator: Helper.arraySortingAgGrid,
            cellRenderer: (params) => {
                const values = params.value || [];
                return (
                    <div className={values.length !== 1 ? 'updated-value' : ""}>
                        {values.map((val, idx) => (
                            <div key={idx}>
                                {val}{idx < values.length - 1 ? ',' : ''}
                            </div>))}
                    </div>
                );
            },
        },
        {
            field: 'oldValue',
            headerName: 'PREVIOUS VALUE',
            headerTooltip: 'PREVIOUS VALUE',
            minWidth: 218,
            unSortIcon: true,
            sortable: true,
            comparator: Helper.arraySortingAgGrid,
            cellRenderer: (params) => {
                const values = params.value || [];
                return (
                    <div className={values.length !== 1 ? 'updated-value' : ""}>
                        {values.map((val, idx) => (
                            <div key={idx}>
                                {val}{idx < values.length - 1 ? ',' : ''}
                            </div>))}
                    </div>
                );
            },
        },
        {
            field: 'updatedBy',
            headerName: 'UPDATED BY',
            headerTooltip: 'UPDATED BY',
            unSortIcon: true,
            sortable: true,
            comparator: Helper.textSortingAgGrid,
        },
        {
            field: 'updatedOn',
            headerName: 'UPDATED ON',
            headerTooltip: 'UPDATED ON',
            unSortIcon: true,
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                suppressAndOrCondition: true,
                comparator: Helper.calendarAgGridComparator,
            },
        },
        {
            field: 'comment',
            headerName: 'COMMENT',
            headerTooltip: 'COMMENT',
            unSortIcon: true,
            sortable: true,
            comparator: Helper.textSortingAgGrid,
        },
    ]);

    useEffect(() => {
        const data = auditList?.map(item => ({
            fieldName: item.fieldName,
            newValue: item?.newValue ? item.newValue.split('\r\n') : [],
            oldValue: item?.oldValue ? item.oldValue.split('\r\n') : [],
            updatedBy: item.updatedBy,
            comment: item.comment,
            updatedOn: item.updatedOn ? Helper.convertDateFormatToMMDDYYYY(item.updatedOn) : "",
        }));
        setRowData(data);
    }, [auditList]);

    const defaultColDef = useMemo(() => ({
        flex: 1,
        sortable: true,
        filter: true,
        enableRowGroup: true,
        enableValue: true,
        resizable: true,
        autoHeight: true,
    }), []);

    return (
        <div className="avnet-modal modal-1250">
            <div className="avnet-modal-inner">
                {/* Modal Header */}
                <button type="button" className="close py-3" data-dismiss="modal" onClick={onHide}>×</button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading pl-5">Audit Logs</h3>
                </div>

                {/* Modal Body */}
                <div className="modal-body adminconsole-container">
                    {__check(['ADMIN_AUDIT_LOG_LIST']).render}
                    {!__check(['ADMIN_AUDIT_LOG_LIST']).status && (
                        auditList?.length > 0 ? (
                            <div className="ag-theme-alpine ag-grd-hg mb-5 auditlog-table">
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    rowSelection="multiple"
                                    suppressRowClickSelection={true}
                                    autoGroupColumnDef={{
                                        headerName: 'Group',
                                        minWidth: 220,
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="mt-4">
                                <NoResultContent
                                    message={`Sorry! No Result Found.`}
                                    isDisplay={false}
                                />
                            </div>
                        )
                    )}
                </div>

                {/* Modal Footer */}
                <div className="modal-footer text-center">
                    <div className="modal-footer-actions">
                        <button
                            type="button"
                            className="bs5 btn btn-primary btn-sm w145"
                            data-bs-toggle="modal"
                            data-bs-target="#RequestModal"
                            onClick={onHide}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderAuditLogPopup;
